var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckWithDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 5.68629 2.68629 3 6 3H14C17.3137 3 20 5.68629 20 9V17C20 20.3137 17.3137 23 14 23H6C2.68629 23 0 20.3137 0 17V9Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 4,
    r: 3.5,
    fill: "#E23E5C",
    stroke: "#E7F0F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66128 14.0271L7.84737 16.2663C8.24004 16.6685 8.88697 16.6681 9.2792 16.2655L14.3392 11.0714C14.7069 10.694 14.7069 10.0922 14.3392 9.71477C13.9576 9.32307 13.3281 9.32307 12.9465 9.71477L8.56176 14.2158L7.05248 12.6692C6.67044 12.2777 6.04073 12.2784 5.65959 12.6708C5.29252 13.0486 5.29327 13.6501 5.66128 14.0271Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckWithDot);
export default __webpack_public_path__ + "static/media/icon-check-with-dot.3aa219b74e49249875751d2b4984ec44.svg";
export { ForwardRef as ReactComponent };